exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/course-integrations-callback.js-WebpackMultiOutput";